<div class="table-container">
    <h1>Accesorii</h1>
    <br/>
    <table>
      <thead>
        <tr>
          <th>Crt</th>
          <th>Denumire Taxa</th>
          <th>Categorie</th>
          <th>IBAN</th>
          <th>Tax ID</th>
          <th>Total</th>
          <th>Observatii</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of data; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ row.tax_name }}</td>
          <td>{{ row.source == 1 ? 'DGITL' : 'DMU' }}</td>
          <td>{{ row.iban }}</td>
          <td>{{ row.tax_id }}</td>
          <td>{{ row.amount }} RON</td>
          <td>{{ row.message || 'n/a' }}</td>
        </tr>
      </tbody>
    </table>
    <br/>
    <div class="button-back-container">
      <button class="button-back" (click)="closeDialog()">Înapoi</button>
    </div>
  </div>
